import React, { useState, useEffect } from 'react';
import Popup from '../popup/Popup';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileLines } from '@fortawesome/free-solid-svg-icons';

export default function InstalmentPlanStatement() {
    const [isPopupOpen, setIsPopupOpen] = useState(false);

    function disableScrolling() {
        var x = window.scrollX;
        var y = window.scrollY;
        window.onscroll = function () { window.scrollTo(x, y); };
    }

    function enableScrolling() {
        window.onscroll = function () { };
    }

    const togglePopup = () => {
        if (!isPopupOpen) {
            disableScrolling();
        } else {
            enableScrolling();
        }

        setIsPopupOpen(!isPopupOpen);
    }

    return (
        <>
            <span className="quote-document" onClick={() => togglePopup()}>Instalment Plan Statement <FontAwesomeIcon icon={faFileLines} /></span>
            {isPopupOpen && <Popup
                content={<>
                    <h1>Instalment Plan Statement</h1>
                    <p>We act as a credit broker and use Close Brothers Limited T/A Close Brothers Premium Finance to arrange finance for the payment of your insurance premium.</p>
                    <p>We'll be paid a commission by Close Brothers for introducing you to them and for managing your finance. We'll also receive commission if you finance mid-term adjustments, annual renewals or additional policies</p>
                    <p>Commission will impact the amount you pay as it's included within the total cost of your premium finance. We set the interest rate for your finance. If you wish to go ahead Close Brothers will contact you to confirm the commission amount in writing and to obtain your consent to us receiving that commission before they can progress your application.</p>
                    <p>If you are a sole trader or a partnership in order to assess your application Close Brothers may use credit scoring, credit reference agencies and automated decision making systems which will leave a footprint on your credit scoring file. They'll also carry out anti-money laundering checks. This assessment will take place after your application has been submitted.</p>
                    <p>Close Brothers will send you a pack, either by email or post, which will include information about your credit agreement and let you know if there are any actions you need to take. It's important that you read this information as it will help you decide whether taking finance is right for you.</p>
                    <p>There are some important things you need to know about the credit agreement:
                        <ul>
                            <li>It's only suitable for financing your insurance policy</li>
                            <li>If you don't make your payments on time:
                                <ul>
                                    <li>You'll be charged a default fee of &pound;25 and</li>
                                    <li>You may be charged late payment interest until the payment is made, meaning the cost of your borrowing may increase</li>
                                </ul>
                            </li>
                            <li>If you don't make payment by the required date:
                                <ul>
                                    <li>Your agreement may be terminated and you'll incur a fee</li>
                                    <li>Your insurance policy may be cancelled; and</li>
                                    <li>Court action may be taken against you for any outstanding monies. You'll be liable for all sums owing and any charges.</li>
                                </ul>
                            </li>
                        </ul>
                    </p>
                    <p>Missing payments may affect your credit rating which may make it more difficult or expensive for you to obtain credit in the future.</p>
                    <p>Should you change your mind, you can withdraw from the credit agreement, free of charge, within 14 days starting the day after you enter into the agreement. Details of how to request this will be in the information pack you'll receive from Close Brothers. You'll then need to find another way to pay for your insurance policy.</p>
                    <p>Also in the pack will be a link to their website and details about how you can contact them about other matters such as payment support, communication preferences, or any other queries or concerns about their product or service.  Should you wish to phone them, the number is 0333 321 8566</p>
                    <p>
                        <b>* If premium exceeds &pound;5000 the fee will be &pound;50</b>
                    </p>
                </>}
                handleClose={togglePopup}
            />}
        </>
    )
}